import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/seoChecklist.actions'
import { hasPropertyChain } from 'helpers/util'
import { sortData } from 'helpers/sortData'

const initialState = {
  checklists: {},
  domains: []
}

const addChecklist = (checklists, { type, payload = {} }) => {
  switch (type) {
    case actions.loadChecklistSuccess.type:
      return {
        ...checklists,
        [payload.domainId]: payload.checklist
      }
    default:
      return checklists
  }
}

const updateChecklist = (checklist, { type, payload = {} }) => {
  const seoStrategy = payload.checklist?.seoStrategy || {}
  switch (type) {
    case actions.updateChecklistSuccess.type:
      return {
        ...checklist,
        [payload.section]: {
          ...checklist[payload.section],
          ...seoStrategy
        }
      }
    default:
      return checklist
  }
}

const checklistReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.loadChecklistSuccess.type:
      if (!hasPropertyChain(state, 'checklists', payload.domainId)) {
        state.checklists[payload.domainId] = {}
      }

      return {
        ...state,
        checklists: {
          ...addChecklist(state.checklists, { type, payload })
        }
      }

    case actions.updateChecklistSuccess.type: {
      let updateDomainChecklist = state.checklists[payload.domainId]
      return {
        ...state,
        checklists: {
          ...state.checklist,
          [payload.domainId]: updateChecklist(updateDomainChecklist, { type, payload })
        }
      }
    }
    case actions.getSeoChecklistDomainsSuccess.type:
      return {
        ...state,
        domains: payload.domains
      }
    case actions.getSeoChecklistDomainsFailure.type:
      return initialState
    case actions.sortSeoChecklistDomains.type: {
      const value = payload.value
      const order = payload.order
      switch (true) {
        case value === 'Sort by':
          state.domains.sort(sortData(['createdAt'], order, value))
          break
        case value === 'A-Z':
          state.domains.sort(sortData(['domain'], order, value))
          break
        case value === 'Completed':
          state.domains.sort(sortData(['score'], order, value))
          break
        default:
          return state.domains
      }

      return {
        ...state,
        domains: [...state.domains]
      }
    }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}

export default checklistReducer
